export function getQueryString(paraName) {
  var reg = new RegExp("(^|&)" + paraName + "=([^&]*)(&|$)");
  if(!window.location.href || window.location.href.split('?').length <= 1){
    return null
  }

  var r = window.location.href.split('?')[1].match(reg);
  if (r != null) {
    return unescape(r[2]);
  } else {
    return null
  }
}

export const getLocal = (name) => {
  return localStorage.getItem(name)
}

export const setLocal = (name, value) => {
  localStorage.setItem(name, value)
}
export const simpleDate = (date)=>{
  let d= new Date(date);
  let month= ''+ (d.getMonth()+ 1);
  let day= ''+ d.getDate();
  let year= d.getFullYear();
  if (month.length< 2)
    month= '0'+ month;
  if (day.length< 2)
    day= '0'+ day;
  return [year, month, day].join('-');
}
